//imports
import {
    PARTNUMBER_DELETE_OPEN_MODAL,
    PARTNUMBER_DELETE_REQUEST,
    PARTNUMBER_DELETE_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    partNumber: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case PARTNUMBER_DELETE_OPEN_MODAL:
            return { ...state, openModal: true, partNumber: action.payload }

        case PARTNUMBER_DELETE_REQUEST:
            return { ...state, loading: true }

        case PARTNUMBER_DELETE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "DELETE_PARTNUMBERS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
